import { atom } from "@byko/lib-recoil";

export const loadingVariantIdCollectionState = atom<number[]>({
  key: "loading-variant-id-collection-state",
  default: [],
});
